/**
 *
 * @module campaign
 *
 */

import Check from 'check-types';

import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class Campaign
 * @desc Provides campaign and voucher codes for a given sku. This will only be populated for direct billing skus.
 *
 */
export default class Campaign {

    /**
     *
     * @param {String} campaignCode
     * @param {String} voucherCode
     * @throws {InvalidArgumentException}
     *
     */
    constructor(campaignCode, voucherCode) {

        const errorMessage = {
            ctor: `${this.constructor.name}(campaignCode, voucherCode)`,
            get campaignCode() {
                return `${this.ctor} options.campaignCode should be a String with length`;
            },
            get voucherCode() {
                return `${this.ctor} options.voucherCode should be a String with length`;
            }
        };

        nonEmptyString(campaignCode, errorMessage.campaignCode, InvalidArgumentException);
        nonEmptyString(voucherCode, errorMessage.voucherCode, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         * @desc Campaign code associated with a sku.
         *
         */
        this.campaignCode = campaignCode;

        /**
         *
         * @access public
         * @type {String}
         * @desc Voucher code associated with a sku.
         *
         */
        this.voucherCode = voucherCode;

    }

}



// WEBPACK FOOTER //
// ./src/services/paywall/campaign.js